import SideTool from '@/global/components/side-tool'
import './index.less'
import { useLocation, useParams } from 'react-router-dom';
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter';
import { useEffect, useState } from 'react';
import { getMonitorParametersByProjectId } from '@/api/monitor-object/monitor-parameter';
import TnMessage from '@/global/components/message';
import MonitorParameterItem from './monitor-parameter-item/item';

export default function MonitorParameterPanel() {
    const location = useLocation(); // 路由
    const { projectId } = useParams();// 路由参数，项目id
    const [list, setList] = useState<MonitorParameter[]>([]); // 监测参数列表
    const [activeItemId,setActiveItemId] = useState<number>(); // 激活的监测参数

    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [projectId]) // 项目id变化时，获得监测参数列表

    // 监听路由，高亮左侧列表
    useEffect(() => {
        let pathName = location.pathname;

        const match = pathName.match(/\/bim\/project\/\d+\/monitor-parameter\/(\d+)/);
        if (match) {
            const id = match[1];
            setActiveItemId(+id);
        } else {
            setActiveItemId(null);
        }
    }, [location.pathname])

    // 根据项目id获得监测参数列表
    const generateData = () => {
        getMonitorParametersByProjectId(+projectId).then(res => {
            let list: MonitorParameter[] = res.data || [];
            setList(list);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得监测参数列表失败")
            }
        })
    }

    return (
        <div className="monitor-parameter-side-container">
            <SideTool />
            <div className="list-main">
                {list.map((item, index) => (
                    <MonitorParameterItem key={index} monitorParameter={item} active={activeItemId == item.id} />
                ))}
            </div>
        </div>
    )
}